<section class="contact">

    <div class="container-redesign">

        <!-- ==========================================
            Header
        ========================================== -->

        <div class="contact__header">

            <span class="contact__eyebrow">

                {{ eyebrow }}

            </span>

            <h1 class="contact__title">

                {{ title }}

            </h1>

            <p class="contact__description">

                {{ description }}

            </p>

        </div>

        <!-- ==========================================
            Content
        ========================================== -->

        <div class="contact__content">

            <!-- ==========================================
                Left Column
            ========================================== -->

            <div class="contact__left">

                <!-- Contact Cards -->

                <div class="contact__info">

                    <div class="contact__card" *ngFor="let item of contactItems; let x = index; trackBy: trackByIndex">

                        <div class="contact__icon">

                            <img [src]="item.icon" [alt]="item.title">

                        </div>

                        <div class="contact__card-content">

                            <h3 class="contact__card-title">

                                {{ item.title }}

                            </h3>

                            <p class="contact__card-line"
                                *ngFor="let line of item.lines; let i = index; trackBy: trackByIndex">

                                <b>{{ x == 0 ? (i == 0 ? 'Head Office: ' : 'Estonia Office: ') : '' }}</b> {{ line
                                }}<br>
                            </p>

                        </div>

                    </div>

                </div>


            </div>

            <!-- ==========================================
                Right Column
            ========================================== -->

            <div class="contact__form-wrapper">

                <h2 class="contact__form-title">

                    {{ formTitle }}

                </h2>

                <form class="contact__form" [formGroup]="form" *ngIf="!sending">

                    <div class="contact__row">

                        <div class="contact__field">

                            <input type="text" formControlName="name" [placeholder]="firstNamePlaceholder">

                        </div>

                        <div class="contact__field">

                            <input type="text" formControlName="company" [placeholder]="companyPlaceholder">

                        </div>

                    </div>

                    <div class="contact__row">

                        <div class="contact__field">

                            <input type="email" formControlName="email" [placeholder]="emailPlaceholder">

                        </div>

                        <div class="contact__field">

                            <input type="text" formControlName="phone" [placeholder]="phonePlaceholder">

                        </div>

                    </div>

                    <div class="contact__field">

                        <input type="text"  formControlName="subject" [placeholder]="subjectPlaceholder">

                    </div>

                    <div class="contact__field">

                        <textarea rows="7"  formControlName="message" [placeholder]="messagePlaceholder"></textarea>

                    </div>

                    <button type="button" (click)="send()" class="cta-banner__button cta-banner__button--primary" >

                        <span>

                            {{ submitButton }}

                        </span>

                        <img src="/assets/img/redesign/flecha.svg" alt="" class="cta-banner__button-icon">

                    </button>

                </form>
                <div class="preloader-flex " *ngIf="sending">
                    <div class="loader">
                        <div class="loader-outter"></div>
                        <div class="loader-inner"></div>
                    </div>
                </div>
                <div *ngIf="mailResult" class="fs-6 ">
                    <span [class.text-danger]="error" [class.text-success]="!error">{{mailResult}}</span>
                </div>
            </div>

        </div>

    </div>

</section>